export default {
	app: false,
	urlApis: null,
	access: false,
	asideStorage:[],
	lateralShow: true,
	selectedItem: null,
	itemSalesAppointmente:(localStorage.getItem('itemSalesAppointmente')!=null) ? JSON.parse(localStorage.getItem('itemSalesAppointmente')) : [],
}
